export default __webpack_public_path__ + "static/media/PHP-logo.svg.de890e6d.png";